/**
 * @description 调用客户端接口
 * @description 客户端在javaScript 引擎中插入相应的函数 ，可在v8.h 文档的 v8::Extension 查看具体的使用详情
 * @param params{Object}
 * @return {null|Object}
 */
export const callRequest = (function (window) {
  return window.chrome &&
    window.chrome.LiebaoCallRequest &&
    typeof window.chrome.LiebaoCallRequest === 'function'
    ? function (params) {
      const ret = window.chrome.LiebaoCallRequest(JSON.stringify(params))
      if (ret) {
        return JSON.parse(ret)
      }
      return null
    }
    : function () {
      console.warn('非猎豹浏览器环境')
    }
}(window))
